const baseUrl = 'http://localhost:4200';

export const environment = {
    production: false,
    application: {
        baseUrl,
        name: 'Car-Booking',
        logoUrl: '',
    },

    apis: {
        default: {
            url: 'https://test.vvcar.vn/api',
        },
        // vietmap: 'https://maps.vietmap.vn'
        googlemap: 'https://googleapis.com',
    },

    keys: {
        // vietmapKey: '20d905441880ad54df735eb37d584ea45c05b51847ecc14f'
        googlemapKey: 'AIzaSyAWW9D35_ek0_nnbeArlJeNVWQ9B55I700',
    },
    firebaseConfig: {
        apiKey: 'AIzaSyD447ubB3v-y740YJVhuKrMQ2loN-Q3JTg',
        authDomain: 'vvcar-89c24.firebaseapp.com',
        projectId: 'vvcar-89c24',
        storageBucket: 'vvcar-89c24.firebasestorage.app',
        messagingSenderId: '976020551690',
        appId: '1:976020551690:web:be6ddd619d66170ff647f3',
        measurementId: 'G-83PH5C55SL',
    },
    vapidKey:
        'BAmN4i8d3vP2YZpXSWO0o8xq8jgq7pW9Bi9kKIIQYsbQwZhqdPW-_5fNsEkKdZKaGDcSw5rtRROhu5b3tn1CjtA', // lấy từ Firebase console
};
